/**
 * [ File :: G_GraphicGrid.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/graphic/G_GraphicMovable.js
 * @목적 : 움직임이 있는 객체의 속성을 처리하는 객체
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
import G_GraphicGrid from 'canvas/grid/dev/child/graphic/G_GraphicGrid';
import B_GridMovable from 'canvas/base/dev/child/grid/B_GridMovable';
import G_Define from 'canvas/grid/dev/util/G_Define';
import B_Define from 'canvas/base/dev/util/B_Define';

let mix = (superclass) => new MixinBuilder(superclass);

const G_GraphicMovable = (function () {

	return class extends mix(G_GraphicGrid).with(B_GridMovable) {

		constructor(obj) { super(obj); }

		/**
		 * [ Function (protected) :: _endAction ]
		 *
		 * @DES :: 액션 종료
		 * @IP1 :: cb {func}
		 * @S.E :: renew() 처리
		 */
		_endAction(cb) {

			// [#] 액션 종료
			this._moveStatus = false;

			// [#] 상태 초기화해서 'action callback'과 'event callback'에 각각 리턴해줍니다.
			const STATE = this.CODMOS.WORLD.STATE.renew();
			if(this.CODMOS.onCanvasEvent) this.CODMOS.onCanvasEvent(STATE);
			if(cb) cb(STATE);
		}

		/**
		 * [ Function (protected) :: _actionCount ]
		 *
		 * @DES :: 액션 카운트
		 * @IP1 :: rtn
		 * @IP2 :: cb
		 * @S.E :: TODO 추후사용예정
		 */
		_actionCount(rtn, cb) {
			if (rtn.play) {
				if (this[from]) this[from]++;
				else this[from] = 1;
			}
			cb();
		}

		/**
		 * [ Function (protected) :: _postMove ]
		 *
		 * @DES :: 움직임 사후처리 (충돌아이템과 추가적인 이벤트 처리)
		 * @IP1 :: target {obj}
		 * @IP2 :: onCanvasEvent {func}
		 */
		_postMove(target, onCanvasEvent) {
			if (typeof target !== "undefined") {
				switch (target._type) {

					case G_Define.GOAL_TYPE : // 목표
					case G_Define.INSPECTOR_TYPE : // 검사자
						target._checkSolution(this, () => {
							onCanvasEvent();
						});
						break;

					case G_Define.OBSTACLE_TYPE : // 장애물
						target._hitHero(() => {
							onCanvasEvent();
						});
						break;

					case G_Define.HIT_ITEM_TYPE : // 아이템 (히트)
						target._hitHero(() => {
							onCanvasEvent();
						});
						break;

					case G_Define.PORTAL_TYPE : // 포탈
						target._movePortal(this, () => {
							onCanvasEvent();
						});
						break;

					default :
						onCanvasEvent();
						break;
				}
			}
			else onCanvasEvent();
		}


		/**
		 * [ Function (public) :: moveForward ]
		 *
		 * @OVERRIDEING
		 * @DES :: 캐릭터 움직임 처리
		 * @IP1 :: cbMoveForward {func}
		 * @O.P :: null
		 */
		moveForward(cbMoveForward) {
			super.moveForward(G_Define.CRUSH_OBJECT, (boolCrushOut, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL) => {
				// /*[T]*/ console.log(boolCrushOut, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL);

				const STATE = this.CODMOS.WORLD.STATE;

				if (boolCrushOut === false && ARR_CRUSH_OBJECT[0] === false) {
					// [#] GRID - pass (그리드 통과)

					// [#] OBJECT
					this._postMove(ARR_CRUSH_OBJECT[1], () => {
						// /*[T]*/ console.log('_postMove call');

						if(ARR_CRUSH_PATH[0] == false) {
							// [#] PATH 충돌없다면 (길밖으로간거지)

							STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON['CRUSH'], null);
							this._endAction((result) => { if (cbMoveForward) cbMoveForward(result); });
						}
						else {
							// [#] PATH 충돌있다면 (길위에있는거지)
							if (
								!ARR_CRUSH_OBJECT[0] // 객체 충돌 없고
								&&
								!ARR_CRUSH_VIRTUAL[0] // 가상 객체 충돌 없고
								&&
								ARR_CRUSH_PATH[1] // 패스 객체 존재 하면
							) {
								ARR_CRUSH_PATH[1]._playCommand(this, () => {
									this._endAction((result) => { if (cbMoveForward) cbMoveForward(result); });
								}, cbMoveForward);
							}
							else {
								this._endAction((result) => { if (cbMoveForward) cbMoveForward(result); });
							}

						}
					});
				} else {
					// [#] GRID - crush (그리드 충돌) => { C타입 게임에서는 진행가능, G타입에선 불가 }

					STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON['CRUSH'], null);
					this._endAction((result) => { if (cbMoveForward) cbMoveForward(result); });
				}

			});


		}

        /**
         * [ Function (public) :: movePortal ]
         */
        movePortal() {
        	super.movePortal();
		}

		/**
		 * [ Function (public) :: jumpForward ]
		 *
		 * @OVERRIDEING
		 * @DES :: 캐릭터 점프 처리
		 * @IP1 :: cbJumpForward {func}
		 * @O.P :: null
		 */
		jumpForward(cbJumpForward) {
			super.jumpForward(G_Define.CRUSH_OBJECT, (boolCrushOut, ARR_CRUSH_PATH, ARR_CRUSH_OBJECT, ARR_CRUSH_VIRTUAL) => {
				const STATE = this.CODMOS.WORLD.STATE;

				if (!boolCrushOut) {
					// [#] GRID - pass (그리드 통과)

					// [#] OBJECT
					this._postMove(ARR_CRUSH_OBJECT[1], () => {
						// [T]
						// console.log('_postMove call');

						// [#] PATH
						if (
							!ARR_CRUSH_OBJECT[0] // 객체 충돌 없고
							&&
							!ARR_CRUSH_VIRTUAL[0] // 가상 객체 충돌 없고
							&&
							ARR_CRUSH_PATH[1] // 패스 객체 존재 하면
						) {
							ARR_CRUSH_PATH[1]._playCommand(this, () => {
								this._endAction((result) => { if (cbJumpForward) cbJumpForward(result); });
							}, cbJumpForward);
						}
						else {
							this._endAction((result) => { if (cbJumpForward) cbJumpForward(result); });
						}
					});
				} else {
					// [#] GRID - crush (그리드 충돌) => { C타입 게임에서는 진행가능 }

					STATE.going(B_Define.CLEAR_STATUS['FAIL'], G_Define.REASON['CRUSH'], null);
					this._endAction((result) => { if (cbJumpForward) cbJumpForward(result); });
				}

			});
		}


	}
}());

export default G_GraphicMovable;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/graphic/G_GraphicMovable.js